import reminder from '../../assets/reminder.mp3';
import { useEffect } from 'react';

export const playReminder = () => {
  const alertAudio = new Audio(reminder);
  alertAudio.play();
};

type Props = {
  onPlay?: () => void;
};

export function ReminderSound({ onPlay }: Props): React.ReactNode {
  useEffect(() => {
    playReminder();
    onPlay?.();
  }, [onPlay]);

  return null;
}
